import { Box, Chip, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

export type PartnerWorkerDetailExperienceProps = {
  data: {
    salaryScale?: number;
    salaryStep?: number;
    contractHours?: number;
    startDate?: string;
    endDate?: string;
  };
};

export const PartnerWorkerDetailExperience = (props: PartnerWorkerDetailExperienceProps) => {
  const { t } = useTranslation('partner-screen-specific');
  return (
    <BoxStyled>
      <StyledChip
        label={`${t('partner_worker_detail.salary_scale')}: ${props.data.salaryScale ?? '--'}`}
      />
      <StyledChip
        label={`${t('partner_worker_detail.salary_step')}: ${props.data.salaryStep ?? '--'}`}
      />
      <StyledChip
        label={`${t('partner_worker_detail.contract_hours')}: ${props.data.contractHours ? props.data.contractHours.toString() + ' uur' : '--'}`}
      />
      <StyledChip
        label={`${t('partner_worker_detail.start_date')}: ${props.data.startDate ?? '--'}`}
      />
      <StyledChip label={`${t('partner_worker_detail.end_date')}: ${props.data.endDate ?? '--'}`} />
    </BoxStyled>
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.lwPrimaryAccentLight[5],
}));

const BoxStyled = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: '8px',
}));
